import { generateStoryEnd } from '@/api/story';
import { createStore } from 'vuex';

export default createStore({
  state: {
    story: null,
    continuationCount: 0,
    isGeneratingEnd: false // 添加标志位
  },
  mutations: {
    CLEAR_STORY(state) {  // 新增清除故事的mutation
      state.story = null;
    },
    setStory(state, story) {
      console.log('Setting story:', story); // 添加日志
      state.story = story;
    },
    incrementContinuationCount(state) {
      console.log('Incrementing continuationCount:', state.continuationCount); // 添加日志
      state.continuationCount += 1;
    },
    SET_IS_GENERATING_END(state, value) { // 新增 mutation
      state.isGeneratingEnd = value;
    },
    SET_CONTINUATION_COUNT(state, count) {
      state.continuationCount = count
    }
  },
  actions: {
    async fetchStory({ commit , state}) {
      console.log('开始调用fetchstory')
      if (state.isGeneratingEnd){
        console.log('有结局正在生成')
        return; // 如果正在生成结局，直接返回
      }
      console.log('fetchStory called'); // 添加日志
      try {
        const response = await generateStoryEnd( {
          end_requirements: '' // 根据需要传递参数
        });
        commit('setStory', response); // 将数据提交到 Vuex 状态
      } catch (error) {
        console.error('Failed to fetch story:', error);
        throw error;
      }finally{
        this.loading =true
      }
    },
    updateStory({ commit }, story) {
      console.log('Updating story:', story); // 添加日志
      commit('setStory', story);
    },
    incrementContinuationCount({ commit }) {
      console.log('Incrementing continuationCount action'); // 添加日志
      commit('incrementContinuationCount');
    },
    setIsGeneratingEnd({ commit }, value) { // 新增 action
      commit('SET_IS_GENERATING_END', value);
    },
    resetContinuationCount({ commit }) {
      commit('SET_CONTINUATION_COUNT', 0)
    }
  },
});